import React from 'react';
import { Button } from '@mui/material';

const UploadArrowIcon = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 64 64"
    fill="white"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M26 48h12V28h14L32 6 12 28h14v20z" />
    <rect x="10" y="52" width="44" height="6" rx="3" ry="3" />
  </svg>
);

export default function UploadButton({ onClick }) {
  const handleFileChange = (e) => {
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <Button
      component="label"
      variant="contained"
      startIcon={<UploadArrowIcon />}
      sx={{
        mb: 1,
        backgroundColor: '#94C940',
        color: 'white',
        borderRadius: '8px',
        px: 3,
        py: 0,
        fontWeight: '1000',
        fontFamily: 'Anek Latin',
        fontSize: '1.4rem',
        textTransform: 'uppercase',
        '&:hover': {
          backgroundColor: '#94C940',
        }
      }}
    >
      Upload
      <input
        type="file"
        hidden
        multiple
        onChange={handleFileChange}
      />
    </Button>
  );
}